import { Contact } from '../contact';
import { Explore } from '../explore';
import styles from './index.module.scss';

export const Mobile = () => {
    return (
        <div className={styles.mobile}>
            <Contact />
            <Explore />
            <span className={styles.logo}>Timothée Dumas</span>
        </div>
    );
};